import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-banned-user-modal',
  templateUrl: './banned-user-modal.component.html',
  styleUrls: ['./banned-user-modal.component.scss']
})
export class BannedUserModalComponent {

  shouldShowModal: boolean;
  @Output() toggleVisibility = new EventEmitter<void>();

  constructor(
    public bsModalRef: BsModalRef,
  ) { }

  onClose() {
    this.bsModalRef.hide();
  }

}
